<!-- eslint-disable max-len -->
<template>
  <footer
    class="w-full h-52 bg-gray-100 flex justify-items-center text-gray-500 font-bold text-3xl text-center"
  >
    <!-- <p class="text-gray-500 font-bold text-3xl text-center" style="max-hight:3rem;">
             Matkortet.com
        </p> -->
    Matkortet
  </footer>
</template>

<script>
export default {};
</script>
